import "./PhilosophySection.css"
import "../App.css"

const PhilosophySection = () => {
    return (
        <div className="philosophy-section-container">
            <div className="philosophy-content-container">
                <div className="section-title">
                    Philosophy
                </div>
                <div className="philosophy-content-section">
                    <div className="philosophy-text-content">
                        Through the use of Polarized Training (Heart rate based training), with proper recovery and a fitness/life balance, custom plans are created for each athlete to attain their goals.
                    </div>
                </div>
            </div>
        </div>
    );
}
export default PhilosophySection;